import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import GenericKP11CardNumberInput from '../kp-11-generic-cards/kp11-generic-card-number-input'
import {normalizeQuantity} from '../../../../kp-11Link-utility/kp11-utility'
import {selectKeapAddUsersQuantity} from '../../../../../../../app-store/kp11CartSlice'

const KP11KeapAdditionalUsers = ({
  name,
  price,
  isChecked,
  groupKey,
  itemCode,
  onSave,
  quantity,
  billingType,
  selectedCountry,
}) => {
  const keapAddUsersQuantity = useSelector(selectKeapAddUsersQuantity)
  // Use Redux quantity when prop is undefined (e.g. initial load from account)
  const effectiveQuantity = quantity ?? keapAddUsersQuantity
  const [value, setValue] = useState(
    String(normalizeQuantity(effectiveQuantity)),
  )
  const [isExpanded, setIsExpanded] = useState(isChecked)
  const existingQuantity = Math.max(
    Number(quantity) || 0,
    Number(keapAddUsersQuantity) || 0,
  )

  useEffect(() => {
    setValue(String(normalizeQuantity(effectiveQuantity)))
  }, [quantity, keapAddUsersQuantity])

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  // Min 1 for new accounts; when existing quantity > 0, min = existing to prevent downgrade
  const minQuantity = existingQuantity > 0 ? existingQuantity : 1

  const handleChange = newValue => {
    setValue(newValue)
  }

  return (
    <GenericKP11CardNumberInput
      name={name || 'Additional Users'}
      price={price}
      billingType={billingType}
      isChecked={isExpanded}
      onClick={() => setIsExpanded(true)}
      label="Number of Users"
      value={value}
      onChange={handleChange}
      min={minQuantity}
      max={99}
      groupKey={groupKey}
      itemCode={itemCode}
      onSave={finalValue => onSave(finalValue)}
      existingquantity={existingQuantity}
      quantityValidationRequired={true}
      selectedCountry={selectedCountry}
    />
  )
}

export default KP11KeapAdditionalUsers
